module.exports = __webpack_public_path__ + "static/media/knight.998fe9ac.jpg";